import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRateReview = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.99984 18.667H12.0998L18.7332 12.0003C18.9332 11.8003 19.0832 11.5725 19.1832 11.317C19.2832 11.0614 19.3332 10.8114 19.3332 10.567C19.3332 10.3225 19.2832 10.0837 19.1832 9.85033C19.0832 9.61699 18.9443 9.40033 18.7665 9.20033L17.5332 7.93366C17.3332 7.73366 17.1109 7.58366 16.8665 7.48366C16.6221 7.38366 16.3665 7.33366 16.0998 7.33366C15.8554 7.33366 15.6109 7.38366 15.3665 7.48366C15.1221 7.58366 14.8998 7.73366 14.6998 7.93366L7.99984 14.567V18.667ZM16.0665 11.867L14.7998 10.6337L16.0998 9.33366L17.3332 10.6003L16.0665 11.867ZM14.9332 18.667H23.9998V16.0003H17.5998L14.9332 18.667ZM2.6665 29.3337V5.33366C2.6665 4.60033 2.92761 3.97255 3.44984 3.45033C3.97206 2.9281 4.59984 2.66699 5.33317 2.66699H26.6665C27.3998 2.66699 28.0276 2.9281 28.5498 3.45033C29.0721 3.97255 29.3332 4.60033 29.3332 5.33366V21.3337C29.3332 22.067 29.0721 22.6948 28.5498 23.217C28.0276 23.7392 27.3998 24.0003 26.6665 24.0003H7.99984L2.6665 29.3337Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgRateReview);
export default ForwardRef;
